import { gql } from '@apollo/client';

export const rankingStudentFragment = gql`
  fragment RankingStudent on RankingStudent {
    id: _id
    name
    email
    group

    scores
  }
`;

export const generalRankingStudentFragment = gql`
  fragment GeneralRankingStudent on GeneralRankingStudent {
    id: _id
    name
    email
    group
    time
    score
    position
  }
`;

export const rankingItemFragment = gql`
  fragment RankingItem on RankingItem {
    id: _id
    name
    scores
    stats
    timeLimit
  }
`;

export const rankingStatsFragment = gql`
  fragment RankingStats on RankingStats {
    average
  }
`;
